export default __webpack_public_path__ + "static/media/large.492a1b82.jpg";